import { dismissCharmSuggestions, showCharmSuggestions } from '../actions/charmSuggestionActions';
import { getStore } from 'owa-calendar-charm-suggestions-store/lib/store';
import { mutator } from 'satcheljs';

/**
 * Dismisses the charm suggestions
 */
export let dismissCharmSuggestionsMutator = mutator(dismissCharmSuggestions, actionMessage => {
    let charmSuggestionsStore = getStore();

    if (charmSuggestionsStore) {
        charmSuggestionsStore.shouldShowSuggestions = false;
    }
});

/**
 * Updates the charm in the calendar event
 */
export let showCharmSuggestionsMutator = mutator(showCharmSuggestions, actionMessage => {
    let charmSuggestionsStore = getStore();

    if (charmSuggestionsStore) {
        charmSuggestionsStore.shouldShowSuggestions = true;
    }
});
